import { c as _c } from "react/compiler-runtime";
import { useTextField } from "@website/ui/text-field/text-field.hook";
import styles from "@website/ui/text-field/text-field.module.scss";
import { TextFieldPropertiesType } from "@website/ui/text-field/text-field.types";
import { FC, useEffect } from "react";
export const TextField: FC<TextFieldPropertiesType> = properties => {
  const $ = _c(47);
  const {
    className,
    inputClassName,
    disabled,
    error,
    EndIcon,
    fullWidth,
    helperText,
    label,
    prefix,
    rows,
    size,
    StartIcon,
    staticDirection,
    suffix,
    hasFocusStyle: t0,
    multiLine: t1,
    type,
    accept,
    noBorder,
    labelClassName,
    id,
    autoFocus
  } = properties;
  const hasFocusStyle = t0 === undefined ? true : t0;
  const multiLine = t1 === undefined ? false : t1;
  const {
    inputReference,
    rootProperties,
    inputProperties,
    startIconProperties,
    endIconProperties
  } = useTextField(properties);
  let t2;
  if ($[0] !== autoFocus || $[1] !== inputReference?.current) {
    t2 = () => {
      if (autoFocus) {
        const timer = setTimeout(() => inputReference?.current?.focus(), 250);
        return () => clearTimeout(timer);
      }
    };
    $[0] = autoFocus;
    $[1] = inputReference?.current;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== noBorder) {
    t4 = noBorder?.map(_temp).join(" ");
    $[4] = noBorder;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `${styles["text-field"]} ${error ? styles.error : ""} ${disabled ? styles.disabled : ""} ${styles[size || "default"]} ${fullWidth ? styles.fullWidth : ""} ${t4} ${className ?? ""}`;
  const t6 = `${className} ${styles.box} ${hasFocusStyle ? styles["box__has-focus"] : ""}`;
  let t7;
  if ($[6] !== StartIcon || $[7] !== startIconProperties) {
    t7 = StartIcon ? <div {...startIconProperties} className={styles["start-icon"]}>{StartIcon}</div> : null;
    $[6] = StartIcon;
    $[7] = startIconProperties;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== prefix) {
    t8 = prefix ? <div className={styles.prefix}>{prefix}</div> : null;
    $[9] = prefix;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== accept || $[12] !== inputClassName || $[13] !== inputProperties || $[14] !== label || $[15] !== multiLine || $[16] !== rows || $[17] !== staticDirection || $[18] !== type) {
    t9 = multiLine ? <textarea className={`${inputClassName} ${styles.input} ${label ? styles["has-label"] : ""} ${styles["no-resize"]} block h-full`} rows={rows} {...inputProperties} /> : <input accept={accept} type={type} {...inputProperties} className={`${inputClassName} ${styles.input} ${label ? styles["has-label"] : ""} ${staticDirection ? styles[staticDirection] : ""} ${styles.dense}`} />;
    $[11] = accept;
    $[12] = inputClassName;
    $[13] = inputProperties;
    $[14] = label;
    $[15] = multiLine;
    $[16] = rows;
    $[17] = staticDirection;
    $[18] = type;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== suffix) {
    t10 = suffix ? <div className={styles.suffix}>{suffix}</div> : null;
    $[20] = suffix;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== EndIcon || $[23] !== endIconProperties) {
    t11 = EndIcon ? <div {...endIconProperties} className={styles["end-icon"]}>{EndIcon}</div> : null;
    $[22] = EndIcon;
    $[23] = endIconProperties;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== StartIcon || $[26] !== label || $[27] !== labelClassName || $[28] !== prefix) {
    t12 = label ? <label className={`${styles.label} ${labelClassName} ${prefix || StartIcon ? styles.active : ""}`}>{label}</label> : null;
    $[25] = StartIcon;
    $[26] = label;
    $[27] = labelClassName;
    $[28] = prefix;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t13 = <div className={t6}>{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== helperText) {
    t14 = helperText ? <div className={styles["helper-text"]}>{helperText}</div> : null;
    $[38] = helperText;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== error || $[41] !== id || $[42] !== rootProperties || $[43] !== t13 || $[44] !== t14 || $[45] !== t5) {
    t15 = <div className={t5} {...rootProperties} data-error={error} id={id}>{t13}{t14}</div>;
    $[40] = error;
    $[41] = id;
    $[42] = rootProperties;
    $[43] = t13;
    $[44] = t14;
    $[45] = t5;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
};
function _temp(item) {
  return `${styles[`no-border-${item}`]}`;
}